<div class="dollhouse-wrapper" [graingerBackgroundImage]="'/assets/images/supplier-bg.png'"></div>

<div class="content-wrapper">
    <div class="screen"></div>
    <grainger-subpage-header
        class="popup-header"
        [button]="{ name: 'Choose a Facility', url: '..' }"
        [hasFloatingButton]="true"
        [hasEditModeToggle]="false"
        [floatWithElement]="tabs"
        (buttonClicked)="trackHeaderClick('Clicked choose a facility')"
    >
    </grainger-subpage-header>
    <main class="content">
        <div class="header">
            <div class="header__left">
                <h1 class="header__title">Government & Healthcare Contracts</h1>
            </div>

            <div class="header__right"></div>
        </div>
        <div class="c-tabs">
            <div #tabsEl class="c-floating-tabs">
                <div class="tabs" [ngClass]="{ 'tabs--scrolled': tabScrolled }">
                    <div class="c-tab">
                        <a
                            class="tab"
                            routerLink="national-cooperative"
                            routerLinkActive="active"
                            (click)="trackTabClick('Clicked tab - ' + 'National Cooperative')"
                            #nationalCooperativeTab="routerLinkActive"
                        >
                            National Cooperative
                        </a>
                    </div>
                    <div class="c-tab">
                        <a
                            class="tab"
                            routerLink="federal"
                            routerLinkActive="active"
                            (click)="trackTabClick('Clicked tab - ' + 'Federal')"
                        >
                            Federal
                        </a>
                    </div>
                    <div class="c-tab">
                        <a
                            class="tab"
                            routerLink="healthcare-gpo"
                            routerLinkActive="active"
                            (click)="trackTabClick('Clicked tab - ' + 'Healthcare GPO')"
                        >
                            Healthcare GPO
                        </a>
                    </div>
                </div>
            </div>
            <div class="page-content">
                <router-outlet></router-outlet>
            </div>
        </div>
    </main>
</div>
